const missionControl = {
  header: {
    title: 'Control de la misión',
    createScenario: 'Construye un nuevo escenario',
  },

  cards: {
    titles: {
      co2Savings: 'Ahorro de CO2',
      onTimePerfformance: 'Perforación a tiempo',
      vehicleEfficiency: 'Eficiencia del vehículo',
      passengerSatisfaction: 'Satisfacción del pasajero',
      costPerMile: 'Coste por milla',
    },
  },

  layers: {
    title: 'Capa de mapa',

    titles: {
      visibility: 'Visibilidad',
      layerDate: 'Datos de la capa',
      visualRepresenatation: 'Representación visual',
    },

    filters: {
      status: {
        title: 'Estado',
        placeholder: 'Estado',
        options: {
          new: 'Nuevo',
          on_hold: 'En espera',
          routing: 'Ruteo',
          routed: 'Ruteado',
          canceled: 'Cancelado',
          picked: 'Recogido',
          dropped: 'Dejado',
          noshow: 'Noshow',
          queued: 'En cola',
        },
      },

      zones: {
        title: 'Zona',
      },

      powerType: {
        title: 'Poder de carga',
        placeholder: 'Poder de carga',
        options: {
          fast: 'Rápido',
          slow: 'Lento',
          turbo: 'Turbo',
        },
      },

      connectorType: {
        title: 'Tipo de conector',
        placeholder: 'Tipo de conector',
        options: {
          EC_Type_1: 'IEC Tipo 1',
          IEC_Type_2_J1772: 'IEC tipo 2 (J1772)',
          IEC_Type_2: 'IEC Tipo 2',
          IEC_Type_3: 'IEC Tipo 3',
          CHAOJI: '',
          NEMA: '',
          TESLA: 'TESLA',
          CHADEMO: 'CHADEMO',
          GBT: 'GBT',
        },
      },
    },

    content: {
      traffic: {
        title: 'Tráfico',
        description: 'Descripción de la capa que explica lo que mostramos en el mapa',
        mildlyhigher: 'Algo más alto',
        trafficJam: 'Atasco de tráfico',
      },

      evsChargingPoints: {
        title: 'Puntos de carga de vehículos eléctricos',
        description: 'Descripción de la capa que explica lo que mostramos en el mapa',
        chargingPointOptions: {
          fast: 'Punto de carga rápido',
          slow: 'Punto de carga lento',
        },
      },

      heatMap: {
        title: 'Mapa de Calor',
        description: 'Descripción de la capa que explica lo que mostramos en el mapa',
        scaleOfDemand: 'Escala de demanda',
      },

      dots: {
        title: 'Puntos',
        description: 'Descripción de la capa que explica lo que vimos en el mapa',
        numberOfDemands: 'Cantidad de demanda',
      },

      tripsLiveStream: {
        title: 'Transmisión en vivo de viajes',
        description: 'Descripción de la capa que explica lo que mostramos en el mapa',
        tripProgress: 'Progreso de la expedición',
        pickUp: 'Recoger',
        dropOff: 'Dejar',
      },
    },
  },

  kpis: {
    title: 'KPIs',

    titles: {
      driversAndVehicles: 'Conductores y vehículos',
      routes: 'Rutas',
    },
  },
};

export default missionControl;
